import { Project } from '../../query-hooks/gray-projects';
import styles from './details-list.module.scss';
import texts from './details-list.texts.json';
import cn from 'classnames';
import React from 'react';
import { DetailsListItem } from './details-list-item/details-list-item';

type Props = {
  className?: string;
  project: Project;
};

export const DetailsList = ({
  className,
  project: { buildings, apartments, toFloor },
}: Props) => {
  return (
    <ul className={cn(styles.detailsListBox, className)}>
      {buildings && (
        <DetailsListItem term={texts.buildings} value={buildings} />
      )}
      {apartments && (
        <DetailsListItem term={texts.apartments} value={apartments} />
      )}
      {toFloor && <DetailsListItem term={texts.floors} value={toFloor} />}
    </ul>
  );
};
